import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center"
};
import Flag from "@/modules/vue/components/Flag.vue";
import ActionScreen from "@/modules/action-screens/components/ActionScreen.vue";
import FormGroup from "@/modules/vue/components/FormGroup.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'PlayerPlanedCareerEndActionScreen',
  props: {
    player: null
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(ActionScreen, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(Flag, {
          country: __props.player.country,
          class: "mr-1"
        }, null, 8, ["country"]), _createTextVNode(" " + _toDisplayString(__props.player.name) + " (" + _toDisplayString(__props.player.age) + ") ", 1)])]),
        subTitle: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('end_of_career')), 1)]),
        default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('player_will_not_extend_the_contract_and_end_career_when_contract_expires')), 1), _createVNode(FormGroup, {
          label: _ctx.$t('remaining_contract'),
          "value-width-ratio": .5
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$duration(__props.player.contractYears, 'years').humanize()), 1)]),
          _: 1
        }, 8, ["label"])]),
        _: 1
      }, 16);
    };
  }
});